import React from 'react'
import "../styles/experience.css"

const Education = () => {
    return (
        <div className="edu-cont" data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-offset="0">
            <div className="course-name"><h3>Bachelor in CSE</h3></div>
            <div className="ogpa">7.6/10</div>
            <div className="college"><h3>College of Technology and Engineering</h3></div>
            <div className="duration">2019 - 2023</div>
            <div className='hor-line'></div>
        </div>
    )
}

export default Education
